export const SET_ROUTER_HISTORY = "SET_ROUTER_HISTORY";

export function setRouterHistory(data) {
    return {
        type: SET_ROUTER_HISTORY,
        data
    }
}

